import http from '@xhs/http'
import TokenUniqueUploader from './TokenUniqueUploader'
import {
  QCLOUD_BUCKET_CDN_MAP, PROD_HOST, LOGAN_HOST, QCLOUD_SIGN,
} from './const'

const isProd = process.env.NODE_ENV === 'production'
const tokenUrl = `${isProd ? PROD_HOST : LOGAN_HOST}${QCLOUD_SIGN}`

const { post, get } = http

export class ImageUploader extends TokenUniqueUploader {
  xCosSecurityToken = ''

  url = ''

  constructor({
    bucket, bizKey, keyPattern,
    contentType, useAccelerate = false,
  } = {}) {
    if (typeof bucket === 'undefined' || typeof bizKey === 'undefined') {
      throw new Error('[Image Uploader Exception]: {bucket} and {bizKey} is required!')
    }
    super({
      bucket,
      bizKey,
      keyPattern,
      useAccelerate,
      postFile({
        file,
        onProgress,
      }) {
        const key = this.key
        const fd = new FormData()
        const type = contentType || file.type

        if (type) {
          fd.append('Content-Type', type)
        }
        fd.append('Signature', this.token)
        fd.append('x-cos-security-token', this.xCosSecurityToken)
        fd.append('key', key)
        fd.append('file', file)
        const postUrl = this.url

        return post(postUrl, fd, {
          withCredentials: false,
          onUploadProgress: onProgress,
        })
          .then(() => ({
            url: `${this.url}${key}`,
            key,
            cdnUrl: QCLOUD_BUCKET_CDN_MAP[bucket] ? `https://${QCLOUD_BUCKET_CDN_MAP[bucket]}/${key}` : '',
          }))
          .catch(e => {
            throw e
          })
      },
      getToken() {
        return get(tokenUrl, {
          params: {
            // 加上随机数，防止 token 接口被缓存，导致上传异常
            _: Math.random(),
            bucket: this.bucket,
            bizKey: this.bizKey,
            keyPattern: this.keyPattern,
            useAccelerate: this.useAccelerate,
          },
          transform: false,
          withCredentials: false,
        }).then(data => {
          this.key = data.key
          this.token = data.token
          // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
          this.url = data.url && data.url.startsWith('http') ? data.url : `https:${data.url}`
          this.tokenExpiration = data.expiration
          this.xCosSecurityToken = data.xCosSecurityToken
        })
      },
    })

    this.tokenValid = () => Date.now() < this.tokenExpiration * 1000
  }
}
